import React, { useState, useEffect, useContext } from 'react';
import { getDownloadURL, ref } from 'firebase/storage';
import { storage } from './firebase';
import { AppContext } from './AppContext';

const MYDATUserVideos = ({ item, onPress }) => {
  const { albumArtworks } = useContext(AppContext);
  const [artUrl, setArtUrl] = useState(null);

  useEffect(() => {
    if (!item) return;

    // Prefer any locally-cached artwork, otherwise fall back to ArtworkURL
    const preferred =
      (albumArtworks?.[item.contentId] || item?.localArtworkURL || null) ??
      null;
    const candidate = preferred || item?.ArtworkURL || item?.artworkURL || '';

    const resolveUrl = async () => {
      try {
        if (!candidate) {
          setArtUrl(null);
          return;
        }
        if (candidate.startsWith('gs://')) {
          // Strip the bucket and keep the path after the first slash
          const parts = candidate.replace('gs://', '').split('/');
          const path = parts.slice(1).join('/'); // drop bucket name
          const url = await getDownloadURL(ref(storage, path));
          setArtUrl(url);
        } else {
          setArtUrl(candidate);
        }
      } catch (err) {
        console.error('Failed to load video thumbnail:', err);
        setArtUrl(null);
      }
    };

    resolveUrl();
  }, [item, albumArtworks]);

  if (!item) {
    return <div style={styles.videoThumbnailPlaceholder} />;
  }

  return (
    <div
      style={styles.itemContainer}
      onClick={() => onPress && onPress(item)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onPress && onPress(item)}
    >
      {artUrl ? (
        <div style={styles.videoFrame}>
          <img src={artUrl} alt="" style={styles.videoFill} />
        </div>
      ) : (
        <div style={styles.videoThumbnailPlaceholder} />
      )}

      <p style={styles.artistName} title={item?.ArtistName || item?.artistName || ''}>
        {(item?.ArtistName || item?.artistName || '').toString()}
      </p>
      <p
        style={styles.songName}
        title={
          item?.isAlbum
            ? item?.albumName || 'Unknown Album'
            : item?.VideoName || item?.SongName || 'Unknown Video'
        }
      >
        {item?.isAlbum
          ? item?.albumName || 'Unknown Album'
          : item?.VideoName || item?.SongName || 'Unknown Video'}
      </p>
    </div>
  );
};

const styles = {
  // tile sizing similar to the RN half-row feel; adjusts with viewport
  itemContainer: {
    display: 'inline-block',
    width: '140px',
    maxWidth: '38vw',
    marginRight: '10px',
    verticalAlign: 'top',
    cursor: 'pointer',
  },

  // 16:9 box using the padding-top trick
  videoFrame: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%', // 16:9
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#cccccc',
  },
  videoFill: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  videoThumbnailPlaceholder: {
    width: '360px',
    maxWidth: '38vw',
    paddingTop: '56.25%',
    borderRadius: '8px',
    backgroundColor: '#cccccc',
  },

  // tight text like RN's one-line labels
  artistName: {
    margin: '6px 0 0',
    color: 'white',
    fontSize: '0.95rem',
    fontWeight: 'bold',
    lineHeight: 1.1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  songName: {
    margin: '2px 0 0',
    color: '#b8b8b8',
    fontSize: '0.9rem',
    lineHeight: 1.1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export default MYDATUserVideos;
